import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule } from '@pos-app/core-ui';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDialogModule } from '@angular/material/dialog';

import { RegisterAdminComponent } from './register-admin.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, CoreUiModule, NgSelectModule, MatDialogModule],
  declarations: [RegisterAdminComponent],
  exports: [RegisterAdminComponent],
})
export class RegisterAdminModule {}
